var render = function render(){var _vm=this,_c=_vm._self._c;return _c('su-page',[_c('el-row',{staticClass:"mt30",attrs:{"slot":"content"},slot:"content"},[_c('el-row',{domProps:{"innerHTML":_vm._s(_vm.details.content)}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }